import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { KEY_ACCESS_TOKEN, X_API_KEY, KEY_REFRESH_TOKEN, REFRESH_URL, KEY_CONFIG_URL, KEY_AZURE_TOKEN } from '../Helpers/constant';
import { FEED_FEATURE_API_BASE_URL, TURBOVERSE_BASE_URL } from './constants';
import { LoginData, VerifySignUpFormData } from '../interfaces/Auth';
import { EventFormValues, RegisterEvent } from '../interfaces/Events';
import { PaymentData } from '../interfaces/Common';
import { ApplyJob, FormPostJob, FormPostJobFavorite, JobApplyDetails, JobBookmarkDetails, JobDetails, JobUploadDetails } from '../interfaces/Jobs';
import {
  ProfileUserDetails,
  PreferenceDetails,
  EventPreferenceDetails,
  MentorshipPreferenceDetails,
  JobPreferenceDetails,
  EmployeementDetails,
  CertificateDetails,
  AcademicRecords,
} from '../interfaces/Profile';
import storage from '../storageService';
import { TaskAddDetails } from '../interfaces/MentorShip';
import { CreateSurvey } from '../interfaces/Survey';
import { Questionnaire } from '../interfaces/Service';
import Configurl from '../Configurl';
let appConfig: { apiBaseUrl: string; tokenUrl: string } | undefined;
export let axiosInstance: AxiosInstance;
const configUrl = KEY_CONFIG_URL;

const turbosendURL = TURBOVERSE_BASE_URL;
const feedFeatureApiURL = FEED_FEATURE_API_BASE_URL;

export const getAxiosInstance = async () => {
  if (!axiosInstance) {
    const appConfig = await getConfig();

    axiosInstance = axios.create({
      baseURL: appConfig?.apiBaseUrl || 'http://localhost:4000/', // Default to localhost if config is not available
      timeout: 15000,
    });

    axiosInstance.interceptors.request.use(async (req: InternalAxiosRequestConfig) => {
      try {
        const token = await storage.get(KEY_ACCESS_TOKEN);
        req.headers = req.headers || {};
        req.headers['x-api-key'] = X_API_KEY;
        if (token) req.headers['Authorization'] = `${token}`;
        return req;
      } catch (err) {
        console.error('Error retrieving token:', err);
        return req;
      }
    });

    axiosInstance.interceptors.response.use(
      (res) => res,
      async (error) => {
        if (error.response?.status === 401) {
          await storage.clear();
          window.location.href = '/login';
        }
        return Promise.reject(error);
      }
    );
  }

  return axiosInstance;
};

export const generateNewToken = async (refreshtoken: string) => {
  try {
    if (!refreshtoken) throw new Error('No refresh token available');

    console.log('Refreshing token with:', refreshtoken);
    const response = await axiosInstance.post('v1/auth/verify/refreshToken', { refreshToken: refreshtoken });

    if (response.data?.error) {
      console.error('Refresh token invalid:', response.data.error_description);
      throw new Error(response.data.error_description || 'Invalid refresh token');
    }

    const newAccessToken = response.data?.accessToken;
    const newRefreshToken = response.data?.refreshToken;

    if (newAccessToken && newRefreshToken) {
      await storage.set(KEY_ACCESS_TOKEN, newAccessToken);
      await storage.set(KEY_REFRESH_TOKEN, newRefreshToken);
      return { accessToken: newAccessToken, refreshToken: newRefreshToken };
    } else {
      throw new Error('Invalid token response from server');
    }
  } catch (error) {
    console.error('Token refresh failed:', error);
    throw error; // Ensures the error is caught in the interceptor
  }
};

export const getEventsData = async (contactId: any) => {
  try {
    const path = `v1/event/eventmanagement?contactId=${contactId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getRegisterEvents = async (contactId: any) => {
  try {
    const path = `v1/event/getRegisterEvent?contactId=${contactId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getConfig = async (): Promise<any> => {
  try {
    return Configurl;
  } catch (err) {
    return err;
  }
};

export const ContactDeactivationSentOtp = async (contactId: string) => {
  try {
    const path = `/v1/auth/contactdeactivation/sendotp?contactId=${contactId}`;
    const res = await axiosInstance.post(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const submitSignupRequest = async (contactId: string) => {
  try {
    const path = `/v1/auth/submit/signup/request?contactId=${contactId}`;
    const res = await axiosInstance.patch(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const ContactDeactivate = async (payload: any) => {
  try {
    const path = `/v1/auth/contact/deactivate`;
    const res = await axiosInstance.post(path, payload); // Pass payload here
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const ContactDeactivationVerifyOtp = async (contactId: string, otp: string) => {
  try {
    const path = `/v1/auth/contactdeactivation/verify?contactId=${contactId}&otp=${otp}`;
    const res = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getPrefernceDetails = async (contactId: string) => {
  try {
    const path = `/v1/auth/prefernce/details?contactId=${contactId}`;
    const res = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const getdashboardData = async () => {
  try {
    const path = `/v1/auth/dashboarddata`;
    const res = await axiosInstance.get(path);
    return res?.data?.data || []; 
  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    return [];
  }
};


export const getOtp = async (email: string, update: boolean) => {
  try {
    const path = `/v1/auth/send/otp?email=${email}&update=${update}`;
    const res = await axiosInstance.post(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const getSignupOtp = async (data: any) => {
  try {
    const path = `/v1/auth/alumniotp/signup`;

    const res = await axiosInstance.post(path, data); 
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const updateContactCrm = async (id: string, data: any) => {
  try {
    const path = `/v1/auth//update/crm?id=${id}`;
    const res = await axiosInstance.post(path, data);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postKenAlumniPreferenceOfferingAndseekings = async (data: any) => {
  try {
    const path = `/v1/auth/update/postKenAlumniPreferenceOfferingAndseekings`;
    const res = await axiosInstance.post(path, data);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const patchKenAlumniPreferenceOfferingAndseekings = async (id: string, data: any) => {
  try {
    const path = `/v1/auth/patch/patchKenAlumniPreferenceOfferingAndseekings?id=${id}`;
    const res = await axiosInstance.patch(path, data);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getOnboardDetails = async () => {
  try {
    const path = `/v1/auth/signup/details`;
    const res = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const verifyOtp = async (email: string, otp: string) => {
  try {
    const path = `/v1/auth/verify/otp?email=${email}&otp=${otp}`;
    const res = await axiosInstance.post(path);
    return res?.data ?? res;
  } catch (error) {
    return error;
  }
};


export const verifyOtpReset = async (email: string, otp: string) => {
  try {
    const path = `/v1/auth/verify/otpwithContact?email=${email}&otp=${otp}`;
    const res = await axiosInstance.post(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const loginSSO = async (email: string) => {
  try {
    const path = `/v1/auth/sso/user/verify?email=${email}`;
    const response = axiosInstance.get(path);
    return response;
  } catch (error) {
    return error;
  }
};
export const loginSSORegister = async (payload: any) => {
  try {
    const path = `/v1/auth/sso/user/verify/register`;
    const response = axiosInstance.post(path, payload);
    return response;
  } catch (error) {
    return error;
  }
};


export const getSignupDetails = async (contactId: string) => {
  try {
    const path = `/v1/auth/basicdetail?contactId=${contactId}`;
    const response = axiosInstance.get(path);
    return response;
  } catch (error) {
    return error;
  }
};
export const getKenAlumniPreferenceRecordTypeId = async () => {
  try {
    const path = `/v1/auth/getKenAlumniPreferenceRecordTypeId`;
    const response = axiosInstance.get(path);
    return response;
  } catch (error) {
    return error;
  }
};

export const postPreferncesDetails = async (data: any) => {
  try {
    const path = `/v1/auth/prefernce/details`;
    const response = axiosInstance.post(path, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const saveSignupDetails = async (data: any) => {
  try {
    const path = `/v1/auth/basicdetail`;
    const response = axiosInstance.post(path, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const authLogin = async (data: LoginData) => {
  try {
    const path = `/v1/auth/login/verify`;
    console.log('axiosInstance12', axiosInstance);

    const res: any = await axiosInstance.post(path, data);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const resetPassword = async (data: LoginData) => {
  try {
    const path = `/v1/auth/login/reset`;
    const res: any = await axiosInstance.post(path, data);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const socialLinks = async (data: LoginData) => {
  try {
    const path = `/v1/auth/linkedinintegration`;
    const res: any = await axiosInstance.post(path, data);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getEvents = async (contactId: string) => {
  try {
    const path = `/v1/event/fetch/user/events?accountId=${contactId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getCategoryPicklistValue = async () => {
  try {
    const path = `/v1/event/CategoryPicklistValue`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getTypeofStudyPicklistValue = async () => {
  try {
    const path = `/v1/event/typeofStudyPicklistValue`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getTypeofGradePicklistValue = async () => {
  try {
    const path = `/v1/event/typeofGradePicklistValue`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getTargetAudiencePicklistValue = async () => {
  try {
    const path = `/v1/event/TargetAudiencePicklistValue`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getEmployeedetailsPicklistValue = async () => {
  try {
    const path = `/v1/event/getEmployeedetailsPicklistValues`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getEmployeedetailsLocationPicklistValue = async () => {
  try {
    const path = `/v1/event/getEmployeedetailsLocationPicklistValues`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getEvent = async (id: string) => {
  try {
    const path = `/v1/event/fetch/event/ById?eventId=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getFileUrl = async (data: File) => {
  try {
    const path = `/v1/event/create/publicUrl`;
    const form = new FormData();
    form.append('file', data);
    const res: any = await axiosInstance.post(path, form);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const hostEvent = async (payload: EventFormValues) => {
  try {
    const path = `/v1/event/create/event/schedule`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const registerEvent = async (payload: RegisterEvent) => {
  try {
    const path = `/v1/event/new/registration`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const eventPayment = async (payload: PaymentData) => {
  try {
    const path = `/v1/payment/generate/payment`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const cancelEvent = async (id: string) => {
  try {
    const path = `/v1/event/cancel/registration?eventRegistrationId=${id}`;
    const res: any = await axiosInstance.delete(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const deleteEmployment = async (id: string) => {
  try {
    const path = `/v1/user/deleteemployment/${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const deleteAcademicRecord = async (id: string) => {
  try {
    const path = `/v1/user/deleteacedamicrecord/${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const deleteCertificate = async (id: string) => {
  try {
    const path = `/v1/user/deletecertificate/${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getOptions = async (objectName: string, fieldName: string) => {
  try {
    const path = `/v1/helper/getDropDownValues?objectName=${objectName}&fieldName=${fieldName}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getAllJobs = async (conatctId: string) => {
  try {
    const path = `/v1/job/registred/job?contactId=${conatctId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getJob = async (jobId: string) => {
  try {
    const path = `/v1/job/individual/job?jobId=${jobId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const jobApply = async (payload: ApplyJob) => {
  try {
    const path = `/v1/job/apply/job`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postJob = async (payload: FormPostJob) => {
  try {
    const path = `/v1/job/post/job`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getFaq = async () => {
  try {
    const path = `/v1/support/get/faq`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getTicketHistory = async (userId: string) => {
  try {
    const path = `/v1/support/getUserCases?userId=${userId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getCaseDetails = async (caseId: string) => {
  try {
    const path = `/v1/support/getCaseDetails?caseId=${caseId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getNetworks = async (accountId: string) => {
  try {
    const path = `/v1/networks/${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getMentorshipDetails = async (accountId: string) => {
  try {
    const path = `/v1/mentorship/getMentorshipDetails/${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const sentfriendrequest = async (payload: TaskAddDetails) => {
  try {
    const path = `/v1/mentorship/sentfriendrequest`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const scheduleCall = async (payload: TaskAddDetails) => {
  try {
    const path = `/v1/mentorship/scheduleCall`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const friendrAndCallRequest = async (payload: TaskAddDetails) => {
  try {
    // Use dataId in the URL
    const path = `/v1/mentorship/friendrAndCallRequest`;
    const res: any = await axiosInstance.patch(path, payload);

    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const RejectfriendrAndCallRequest = async (payload: TaskAddDetails) => {
  try {
    // Use dataId in the URL
    const path = `/v1/mentorship/friendrAndCallRequestReject`;
    const res: any = await axiosInstance.patch(path, payload);

    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const CallrequestAccept = async (payload: TaskAddDetails) => {
  try {
    // Use dataId in the URL
    const path = `/v1/mentorship/CallRequestAccept`;
    const res: any = await axiosInstance.patch(path, payload);

    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const CallrequestReject = async (payload: TaskAddDetails) => {
  try {
    // Use dataId in the URL
    const path = `/v1/mentorship/CallRequestReject`;
    const res: any = await axiosInstance.patch(path, payload);

    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const getCallRequests = async (accountId: string) => {
  try {
    const path = `/v1/mentorship/getCallRequests/${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getRecentAlumniDetail = async () => {
  try {
    const path = `/v1/networks/home/getRecentAlumniDetail`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const cancelService = async (id: string) => {
  try {
    const path = `/v1/support/delete/case?caseId=${id}`;
    const res: any = await axiosInstance.delete(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const replay = async (id: string) => {
  try {
    const path = `/v1/support/replay?caseid=${id}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getServices = async () => {
  try {
    const path = `/v1/support/get/service`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getServicesById = async (accountId: string) => {
  try {
    const path = `/v1/support/get/service/Id?serviceid=${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const getEventServicesById = async (eventId: string) => {
  try {
    const path = `/v1/support/get/service/Id?eventid=${eventId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getServicesOffering = async () => {
  try {
    const path = `/v1/support/get/serviceoffering`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const picklistValue = async () => {
  try {
    const path = `/v1/job/jobPicklist`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postQuestionnaire = async (payload: Questionnaire) => {
  try {
    const path = `/v1/support/questionnaire`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const postEventQuestionnaire = async (payload: Questionnaire) => {
  try {
    const path = `/v1/event/submitFeedback`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const submitEventQuestionnaire = async (payload: Questionnaire) => {
  try {
    const path = `/v1/event/submitEventFeedback`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postJobFavorite = async (payload: FormPostJobFavorite) => {
  try {
    const path = `/v1/favourite/add/favorite`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const raiseComplaint = async (payload: FormPostJobFavorite) => {
  try {
    const path = `/v1/support/post/case`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const getJobFavorite = async (accountId: string) => {
  try {
    const path = `/v1/favourite/get/user/favorite?accountId=${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postBasicProfileSetting = async (payload: any) => {
  try {
    const path = `/v1/user/profile/update`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getFundList = async (id: string) => {
  try {
    const path = `/v1/fund/list`;
    const res: any = await axiosInstance.get(`${path}/${id}`);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const donation = async (payload: any) => {
  try {
    const path = `/v1/fund/donation/create`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const campaign = async (payload: any) => {
  try {
    const path = `/v1/fund/campaign/create`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postCampaign = async (payload: any, userId: string) => {
  try {
    const path = `/v1/fund/update/${userId}`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const createIntrest = async (payload: any) => {
  try {
    const path = `/v1/fund/createintrest`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getFundEnrollments = async (fundId: string) => {
  try {
    const path = `/v1/fund/fundEnrollments/${fundId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getFundCategories = async () => {
  try {
    const path = `/v1/fund/categories`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const survey = async (payload: any) => {
  try {
    const path = `/v1/survey/create`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const getBasicProfileSetting = async (accountId: string) => {
  try {
    const path = `/v1/user/profile/${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postPreferenceSettings = async (payload: PreferenceDetails) => {
  try {
    const path = `/v1/settings/preference/update`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const postPreferenceSetting = async (payload: PreferenceDetails) => {
  try {
    const path = `/v1/settings/preferences/updates`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getPreferenceSetting = async (accountId: string) => {
  try {
    const path = `/v1/settings/preference/${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postEventPreferenceSetting = async (payload: EventPreferenceDetails) => {
  try {
    const path = `/v1/settings/eventpreference/update`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getEventPreferenceSetting = async (accountId: string) => {
  try {
    const path = `/v1/settings/eventpreference/${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postMentorShipPreferenceSetting = async (payload: MentorshipPreferenceDetails) => {
  try {
    const path = `/v1/settings/mentorshippreference/update`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getMentorShipPreferenceSetting = async (accountId: string) => {
  try {
    const path = `/v1/settings/mentorshippreference/${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postJobPreferenceSetting = async (payload: JobPreferenceDetails) => {
  try {
    const path = `/v1/settings/jobpreference/update`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getJobPreferenceSetting = async (accountId: string) => {
  try {
    const path = `/v1/settings/jobpreference/${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postCompositePreferences = async (payload: {
  allOrNone: boolean;
  compositeRequest: Array<{
    method: string;
    url: string;
    referenceId: string;
    body: {
      RecordTypeId: string;
      Contact__c: string;
      [key: string]: any;
    };
  }>;
}) => {
  try {
    const path = `/v1/settings/composite/preferences/update`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error: any) {
    if (error?.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw error;
  }
};

export const getJobs = async (accountId: string) => {
  try {
    const path = `/v1/job/${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getJobsDetailsById = async (jobId: string) => {
  try {
    const path = `/v1/job/details/${jobId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postJobs = async (payload: JobDetails, accountId: string) => {
  try {
    const path = `/v1/job/create/${accountId}`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getJobsBookmark = async (accountId: string) => {
  try {
    const path = `/v1/job/bookmarks/${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postJobsBookmark = async (payload: JobBookmarkDetails, accountId: string) => {
  try {
    const path = `/v1/job/bookmarks/${accountId}`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getJobsApply = async (accountId: string) => {
  try {
    const path = `/v1/job/apply/${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postJobsApply = async (payload: JobApplyDetails, accountId: string) => {
  try {
    const path = `v1/job/apply/${accountId}`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};


export const deActivateJob = async (jobId: string, payload: JobApplyDetails,) => {
  try {
    const path = `v1/job/deactivatejob/${jobId}`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const deleteResume = async (payload: any,) => {
  try {
    const path = `v1/job/deleteresume/${payload?.contactId}/${payload?.documentId}`;
    const res: any = await axiosInstance.delete(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};


export const getMentorShipTask = async (accountId: string) => {
  try {
    const path = `/v1/mentorship/task/${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postMentorShipTask = async (payload: TaskAddDetails) => {
  try {
    const path = `/v1/mentorship/task/create`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getJobsResume = async (accountId: string) => {
  try {
    const path = `/v1/job/resume/${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getFeeds = async () => {
  try {
    const path = `/v1/social/feeds`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export type FeedFeatureRegisterPayload = {
  userName: string;
  profileUrl: string;
};

export type FeedFeaturePostPayload = {
  title: string;
  content: string;
  fileIds?: string[];
  audience: string;
};

const FeedFeatureInstance = axios.create({
  baseURL: feedFeatureApiURL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const registerFeedFeatureUser = async (payload: FeedFeatureRegisterPayload, accessToken?: string) => {
  try {
    console.log('Feed feature register payload:', payload);
    console.log('Feed feature register accessToken:', accessToken);

    const res = await FeedFeatureInstance.post('/users/register', payload, {
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    });
    console.log('Feed feature register response:', res?.data ?? res);
    return res && res.data ? res.data : res;
  } catch (error: any) {
    console.log('Feed feature register error:', error?.response?.data ?? error);
    if (error?.response?.status === 409) {
      return error.response.data;
    }
    throw error;
  }
};

export const getPortalPosts = async (accessToken?: string, cursor?: string) => {
  try {
    const params = new URLSearchParams({ limit: '10' });
    if (cursor) params.set('cursor', cursor);

    const res = await FeedFeatureInstance.get(`/newsfeed?${params.toString()}`, {
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    });
    return res && res.data ? res.data : res;
  } catch (error) {
    console.log('Portal posts error:', error);
    return error;
  }
};

export const getMyPortalPosts = async (accessToken?: string, page = 1, limit = 10) => {
  try {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    });

    const res = await FeedFeatureInstance.get(`/users/me/posts?${params.toString()}`, {
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    });
    return res && res.data ? res.data : res;
  } catch (error) {
    console.log('My portal posts error:', error);
    return error;
  }
};

export const createPortalPost = async (payload: FeedFeaturePostPayload, accessToken?: string) => {
  try {
    const res = await FeedFeatureInstance.post('/newsfeed', payload, {
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    });
    return res && res.data ? res.data : res;
  } catch (error) {
    console.log('Create portal post error:', error);
    throw error;
  }
};

export const likePost = async (postId: string, accessToken?: string) => {
  try {
    const res = await FeedFeatureInstance.post(`/posts/${postId}/like`, {}, {
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    });
    return res?.data ?? res;
  } catch (error) {
    console.log('Like post error:', error);
    throw error;
  }
};

export const unlikePost = async (postId: string, accessToken?: string) => {
  try {
    const res = await FeedFeatureInstance.delete(`/posts/${postId}/like`, {
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    });
    return res?.data ?? res;
  } catch (error) {
    console.log('Unlike post error:', error);
    throw error;
  }
};

export const getLikeStatus = async (postId: string, accessToken?: string) => {
  try {
    const res = await FeedFeatureInstance.get(`/posts/${postId}/like`, {
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    });
    return res?.data ?? res;
  } catch (error) {
    console.log('Get like status error:', error);
    throw error;
  }
};

export const addComment = async (postId: string, content: string, accessToken?: string) => {
  try {
    const res = await FeedFeatureInstance.post(`/posts/${postId}/comments`, { content }, {
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    });
    return res?.data ?? res;
  } catch (error) {
    console.log('Add comment error:', error);
    throw error;
  }
};

export const listComments = async (postId: string, page = 1, limit = 10, accessToken?: string) => {
  try {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    const res = await FeedFeatureInstance.get(`/posts/${postId}/comments?${params.toString()}`, {
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    });
    return res?.data ?? res;
  } catch (error) {
    console.log('List comments error:', error);
    throw error;
  }
};

export const deleteComment = async (postId: string, commentId: string, accessToken?: string) => {
  try {
    await FeedFeatureInstance.delete(`/posts/${postId}/comments/${commentId}`, {
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    });
  } catch (error) {
    console.log('Delete comment error:', error);
    throw error;
  }
};

export const updatePortalPost = async (postId: string, payload: FeedFeaturePostPayload, accessToken?: string) => {
  try {
    const res = await FeedFeatureInstance.patch(`/posts/${postId}`, payload, {
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    });
    return res && res.data ? res.data : res;
  } catch (error) {
    console.log('Update portal post error:', error);
    throw error;
  }
};

export const deletePortalPost = async (postId: string, accessToken?: string) => {
  try {
    const res = await FeedFeatureInstance.delete(`/posts/${postId}`, {
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    });
    return res;
  } catch (error) {
    console.log('Delete portal post error:', error);
    throw error;
  }
};

export const uploadFeedFeatureFile = async (file: File, accessToken?: string) => {
  try {
    if (!(file instanceof File)) {
      throw new Error('A valid file is required for upload');
    }

    const formData = new FormData();
    formData.append('file', file, file.name);

    const res = await axios.post(`${feedFeatureApiURL}/files/upload`, formData, {
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    });
    return res && res.data ? res.data : res;
  } catch (error) {
    console.log('Feed feature file upload error:', error);
    throw error;
  }
};

export const postJobUploadResume = async (payload: JobUploadDetails) => {
  try {
    const path = `/v1/job/resume`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postEmployeementDetails = async (payload: EmployeementDetails) => {
  try {
    const path = `/v1/user/profile/employmentdetails`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getEmployeementDetails = async (accountId: string | undefined) => {
  try {
    const path = `/v1/user/profile/employmentdetails/${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postProfileCertificateDetails = async (payload: CertificateDetails) => {
  try {
    const path = `/v1/user/certificatedetails`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getProfileCertificateDetails = async (accountId: string) => {
  try {
    const path = `/v1/user/certificatedetails/${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const getNewsLetter = async () => {
  try {
    const path = `/v1/user/newsletter`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const postAcademicRecords = async (payload: AcademicRecords) => {
  try {
    const path = `/v1/user/academicrecords`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getAcademicRecords = async (accountId: string | undefined) => {
  try {
    const path = `/v1/user/academicrecords/${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const postSurvey = async (payload: CreateSurvey) => {
  try {
    const path = `/v1/survey/response`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getSurvey = async (accountId: string | undefined) => {
  try {
    const path = `/v1/survey/${accountId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const eventsCreation = async (payload: any) => {
  try {
    const path = `/v1/event/eventmanagement`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const createSession = async (payload: any) => {
  try {
    const path = '/v1/event/session';
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getSessionDetails = async (eventId: string) => {
  try {
    const path = `/v1/event/sessions?eventId=${eventId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const updateSessionFee = async (payload: any) => {
  try {
    const path = `/v1/event/session`;
    const res: any = await axiosInstance.patch(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const cancelcase = async (payload: any) => {
  try {
    const path = `/v1/support/cancelcase/${payload}`;
    const res: any = await axiosInstance.patch(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const deleteSession = async (payload: any) => {
  try {
    const path = `/v1/event/sessions`;
    const res: any = await axiosInstance.delete(path, { data: payload });
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const eventRegistration = async (payload: any) => {
  try {
    const path = `/v1/event/bookingregistration`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getallGroup = async (contactid: string) => {
  try {
    const path = `/v1/groups/getallGroup?contactid=${contactid}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const getGroupEnrollmentDetail = async (contactId: string, groupId: string) => {
  try {
    const path = `/v1/groups/getGroupEnrollmentDetail?contactId=${contactId}&groupId=${groupId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const LeftGroups = async (id: any) => {
  try {
    const path = `/v1/groups/leftGroups?id=${id}`;
    const res: any = await axiosInstance.post(path, id);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const createGroups = async (payload: any) => {
  try {
    const path = `/v1/groups/createGroup`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const groupEnrollment = async (payload: any) => {
  try {
    const path = `/v1/groups/groupEnrollment`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getEventRegistration = async (eventId: string) => {
  try {
    const path = `/v1/event/bookingregistration/${eventId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const surveyResponse = async (surveyId: string) => {
  try {
    const path = `/v1/survey/get/surveyResponse?surveyId=${surveyId}`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getallresource = async () => {
  try {
    const path = `/v1/infohub/getallresource`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getCollaborators = async (contactId: string) => {
  try {
    const path = `/v1/infohub/getCollaborators?contactId=${contactId}`;
    const res = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getPhotosAndAlbums = async () => {
  try {
    const path = `/v1/infohub/getPhotosandAlbums`;
    const res = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const createFolder = async (data: {
  folderName: string;
  contactId: string;
  collaboratorIds: string[];
  folderType: string;
  coverImage: {
    fileName: string;
    imageUrl: any;
  };
}) => {
  try {
    const path = `/v1/infohub/createfoldersample`;
    const res = await axiosInstance.post(path, data);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const createPhoto = async (data: {
  contactId: string;
  fileName: string;
  folder: string;
  caption: string;
  location: string;
  alumniTagged: string;
  image: {
    fileName: string;
    fileBlob: any;
  };
}) => {
  try {
    const path = `/v1/infohub/createPhoto`;
    const res = await axiosInstance.post(path, data);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getBusinesses = async (contactId: string) => {
  try {
    const path = `/v1/infohub/getBusinesses?contactId=${contactId}`;
    const res = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const listBusiness = async (data: {
  name: string;
  contactIds: string[];
  description: string;
  businessType: string;
  phone: string;
  email: string;
  hidePhone: boolean;
  hideEmail: boolean;
  website: string;
  address: string;
  locationurl: string;
  businessLogo: {
    fileName: string;
    fileBlob: any;
  };
  coverImage: {
    fileName: string;
    fileBlob: any;
  };
}) => {
  try {
    const path = `/v1/infohub/listBusiness`;
    const res = await axiosInstance.post(path, data);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const updateExpressedInterest = async (recordId: string, isInterested: boolean) => {
  try {
    const path = `/v1/infohub/update-interest/${recordId}`;
    const payload = {
      isInterested: isInterested
    };
    const res = await axiosInstance.patch(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const createProspect = async (prospectPayload: {
  businessId: string;
  contactId: string;
  message?: string;
  subject?: string;
  recordTypeId?: string;
}) => {
  try {
    const path = '/v1/infohub/create-prospect';
    const res = await axiosInstance.post(path, prospectPayload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const createBusinessPromotionController = async (prospectPayload: {
  Business__c: string;
  Prospect_Message__c?: string;
  Subject__c?: string;
}) => {
  try {
    const path = '/v1/infohub/create-business-promotion';
    const res = await axiosInstance.post(path, prospectPayload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const deleteBusiness = async (businessId: string) => {
  try {
    const path = `/v1/infohub/business/${businessId}`;
    const res: any = await axiosInstance.delete(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const getBusinessTypes = async () => {
  try {
    const path = `/v1/infohub/business-types`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getYoutubeVideoURL = async () => {
  try {
    const path = `/v1/infohub/getYoutubeVideoURL`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const getProgramSpecializationTypes = async () => {
  try {
    const path = `/v1/infohub/programspecializationtypes`;
    const res: any = await axiosInstance.get(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const deactivateBusiness = async (businessId: string) => {
  try {
    const path = `/v1/infohub/business/${businessId}/deactivate`;
    const res: any = await axiosInstance.patch(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const updateMentorShipTask = async (payload: TaskAddDetails, Id: any) => {
  try {
    const path = `/v1/mentorship/task/update/${Id}`;
    const res: any = await axiosInstance.patch(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const deleteMentorShipTask = async (Id: any) => {
  try {
    const path = `/v1/mentorship/task/delete/${Id}`;
    const res: any = await axiosInstance.delete(path);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const cancelEventRegistration = async (payload: any) => {
  try {
    const path = `/v1/event/bookingregistration`;
    const res: any = await axiosInstance.patch(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const createContact = async (payload: any) => {
  try {
    const path = `v1/user/profile/contact`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const updateaddress = async (payload: any) => {
  try {
    const path = `v1/user/profile/updateaddress`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const createAddress = async (payload: any) => {
  try {
    const path = `v1/user/profile/createAddress`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const updatePreferencesandSkills = async (payload: any) => {
  try {
    const path = `v1/user/profile/updatePreferencesandSkills`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const postApprovalStatus = async (id: string, payload: any) => {
  try {
    const path = `/v1/groups/groupMemberEnrollment/${id}`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};
export const createPreferencesandSkills = async (payload: any) => {
  try {
    const path = `v1/user/profile/createPreferencesandSkills`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

export const Logout = async (payload: any) => {
  try {
    const path = `v1/auth/logout`;
    const res: any = await axiosInstance.post(path, payload);
    return res && res.data ? res.data : res;
  } catch (error) {
    return error;
  }
};

//Turbosend Chat APIs
interface AuthUser {
  refreshToken: { token: string };
  accessToken: { token: string };
  applicantEmail: string;
  applicantId: string;
  accountId?: string;
  applicantName: string;
  contactImage?: string;
  isAdmin: boolean;
  applicationProfile: string;
  contactRoles?: any;
  roles?: any;
  rolesData?: any;
  turbosendToken: {
    idToken: string;
    refreshToken: string;
  };
  turbosend?: any;
}
//Turbosend Chat APIs
const TurbosendInstance = axios.create({
  baseURL: turbosendURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

TurbosendInstance.interceptors.request.use((req: any) => {
  const userData = JSON.parse(`${localStorage.getItem('user')}`) as AuthUser;
  req.headers['Authorization'] = `Bearer ${userData.turbosendToken.idToken}`;
  return req;
});

TurbosendInstance.interceptors.response.use(
  async (response: any) => {
    return response;
  },
  async function (error: any) {
    try {
      const originalRequest = error.config;
      const userData = JSON.parse(`${localStorage.getItem('user')}`) as AuthUser;
      if ((error?.response && error?.response?.status === 401) || error?.response?.status === 500) {
        try {
          const res = await TurbosendInstance.post('/api/auth/refresh-token', {
            refreshToken: userData?.turbosendToken?.refreshToken,
          });
          const newUserData = {
            ...userData,
            turbosendToken: {
              ...userData.turbosendToken,
              idToken: res?.data?.idToken,
            },
          };
          localStorage.setItem('user', JSON.stringify(newUserData));
          await storage.set('user', JSON.stringify(newUserData));
          // Also update the storage service to keep it in sync
          // try {
          //   await storage.set('user', JSON.stringify(newUserData));
          //   // Also update the access token in storage for consistency
          //   // await storage.set(KEY_ACCESS_TOKEN, res?.data?.idToken);

          //   // Dispatch custom event to notify auth context of token refresh
          //   window.dispatchEvent(new CustomEvent('tokenRefreshed', { 
          //     detail: { newUserData } 
          //   }));
          // } catch (storageError) {
          //   console.warn('Failed to update storage service:', storageError);
          // }

          originalRequest.headers['Authorization'] = `Bearer ${res?.data?.idToken}`
          return axios(originalRequest);
        } catch (err: any) {
          if (err?.response?.data?.success === false && err?.response?.data?.error_message === 'jwt expired') {
            window.location.href = '/login';
          } else {
            console.log(err);
          }
        }
      }
    } catch (refreshError) {
      return Promise.reject(refreshError);
    }
    return Promise.reject(error);
  }
);

export const registerUser = async (payload: any) => {
  try {
    const path = `/api/users/create`;
    const res = await TurbosendInstance.post(path, payload);
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const createChatRoom = async (payload: any) => {
  try {
    const path = `/api/chatrooms/create`;
    const res = await TurbosendInstance.post(path, payload);
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const getChatRoom = async (Id: any) => {
  try {
    const path = `/api/chatrooms/userId?userId=${Id}`;
    const res = await TurbosendInstance.get(path);
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const getCommonChatRoom = async (Id1: any, Id2: any) => {
  try {
    const path = `/api/chatrooms/commonChatRooms?userId1=${Id1}&userId2=${Id2}`;
    const res = await TurbosendInstance.get(path);
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const GetRecentMessages = async (Id: any, currentPage: any, perPage: any) => {
  try {
    const path = `/api/chatrooms/get/recent-messages/${Id}`;
    const res = await TurbosendInstance.get(path, {
      params: {
        currentPage,
        perPage,
      },
    });
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const GetlastMessage = async (Id: any) => {
  try {
    const path = `/api/chatrooms/chatRoomId?1&1&chatRoomIds=${Id}`;
    const res = await TurbosendInstance.get(path, {});
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const TurboSendFileUpload = async (data: any) => {
  try {
    const path = `/api/uploadFile`;
    const res = await TurbosendInstance.post(path, data);
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const registerDevice = async (data: any) => {
  try {
    console.log(data, 'data122344555');
    
    const path = `v1/turbosend/registerdevice`;
    const res = await axiosInstance.post(path, {
      userId: data.userId,
      deviceType: 'web',
      token: data.token,
    });
    return res && res.data ? res.data : res;
  } catch (err) {
    console.log(err);
  }
};
export const fcmdelivery = async (data: any) => {
  try {
    const path = `api/fcm/delivery`;
    const res = await axiosInstance.post(path, {
      "notificationId": data.notificationId,
      "token": data.token,
      "deviceType": "web",
      "tokenType": "fcm",
    });
    return res && res.data ? res.data : res;
  } catch (err) {
    console.log(err);
  }
};

// inapp notification
export const getNotifications = async (
  currentPage: any,
  perPage: any,
  userId: any,
  type: any
): Promise<AxiosResponse> => {
  const path = `${turbosendURL}inApp/notifications/fetch?type=user&userId=${userId}`;

  const res: AxiosResponse = await TurbosendInstance.get(path);
  return res;
};

export const getNotificationCount = async (
  currentPage: any,
  perPage: any,
  userId: any
): Promise<AxiosResponse> => {
  const path = `${turbosendURL}inApp/notifications/fetch?type=time-range&timeRange=48&userId=${userId}&currentPage=${currentPage}&perPage=${perPage}`;
  const res: AxiosResponse = await TurbosendInstance.get(path);
  return res;
};

export const getUnreadNotificationCount = async (userId: string): Promise<number> => {
  try {
    const path = `${turbosendURL}inApp/notifications/fetch?type=unseen-count&userId=${userId}`;
    const res: any = await TurbosendInstance.get(path);
    return res?.data?.totalRecords || 0;
  } catch (error) {
    console.error('Error fetching unread notification count:', error);
    return 0;
  }
};

export const updateNotificationCount = async (
  filteredNotifications: any
): Promise<AxiosResponse> => {
  const path = `${turbosendURL}api/inapp/markSeen`;
  const res: AxiosResponse = await TurbosendInstance.post(
    path,
    filteredNotifications
  );
  return res;
};

export const triggerPrivateNotifications = async (
  templatename: any,
  notificationData: any
): Promise<AxiosResponse> => {
  const payload = {
    notificationTemplate: templatename,
    notificationData: notificationData,
  };
  const path = `${turbosendURL}api/notifications/send-private-notification`;
  const res: AxiosResponse = await TurbosendInstance.post(path, payload);
  return res;
};

export const deleteUserfromFirebase = async (
  payload: any
): Promise<AxiosResponse> => {
  const path = `${turbosendURL}api/tokens/${payload.userId}/web/${payload.fcmToken}`;
  const res: AxiosResponse = await TurbosendInstance.delete(
    path,
  );
  return res;
};
